import React from "react";
import { ArrowUpRight } from "lucide-react";

/* The owner's other work. Kept visually quieter than the product pitch above
   it — this is context about who built the tool, not a second sales page. */

const Media = ({ item }) => {
  if (item.embed_url) {
    return (
      <div className="aspect-video w-full overflow-hidden bg-[color:var(--paper-2)]">
        <iframe
          src={item.embed_url}
          title={item.title}
          loading="lazy"
          allow="accelerometer; clipboard-write; encrypted-media; picture-in-picture"
          allowFullScreen
          className="h-full w-full border-0"
        />
      </div>
    );
  }
  if (item.image_url) {
    return (
      <img
        src={item.image_url}
        alt=""
        loading="lazy"
        className="h-44 w-full object-cover"
      />
    );
  }
  return null;
};

export const PortfolioGrid = ({ portfolio }) => {
  const items = portfolio?.items || [];
  if (!items.length) return null;

  return (
    <section className="mt-20" data-testid="portfolio-section">
      <p className="eyebrow">{portfolio.title}</p>
      {portfolio.intro ? (
        <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-[color:var(--ink-soft)]">
          {portfolio.intro}
        </p>
      ) : null}

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => {
          const body = (
            <>
              <Media item={item} />
              <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="text-[20px] font-semibold leading-tight">{item.title}</h3>
                  {item.url ? (
                    <ArrowUpRight
                      className="mt-1 h-4 w-4 shrink-0"
                      style={{ color: "var(--gild)" }}
                    />
                  ) : null}
                </div>
                {item.summary ? (
                  <p className="mt-2 text-[13px] leading-relaxed text-[color:var(--ink-soft)]">
                    {item.summary}
                  </p>
                ) : null}
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {item.year ? (
                    <span className="font-num text-[11px] text-[color:var(--muted-ink)]">
                      {item.year}
                    </span>
                  ) : null}
                  {(item.tags || []).slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full px-2 py-0.5 text-[11px]"
                      style={{ backgroundColor: "var(--paper-2)", color: "var(--ink-soft)" }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </>
          );

          return item.url ? (
            <a
              key={item.id}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`portfolio-${item.id}`}
              className="surface overflow-hidden rounded-xl transition-transform hover:-translate-y-0.5"
            >
              {body}
            </a>
          ) : (
            <article
              key={item.id}
              data-testid={`portfolio-${item.id}`}
              className="surface overflow-hidden rounded-xl"
            >
              {body}
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default PortfolioGrid;
